import React from "react";
import clsx from "classnames";
/**
 * Button implementation, following the UI v3 design system.
 */
export const Button = ({ children, onClick, style = "primary", ...rest }) => {
    return (<button className={clsx("cursor-pointer rounded-full border border-solid border-black px-6 py-2 font-semibold hover:border-gray-700 hover:bg-gray-700 hover:text-white", {
            "bg-black text-white": style === "primary",
            "bg-white text-black": style === "secondary",
        })} onClick={onClick} {...rest}>
      {children}
    </button>);
};
